import Vue from 'vue';

/**
 * Async components are not used here since there's some slight delay when
 * loading them in other async components
 */
Vue.component('box-loader', require('./box-loader.vue'));

require('./datatable-header');
require('./datatable-loader');



// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js